import server from 'common/utils/server';
import {
  createSolicitationAttachment,
  createQaReviewAttachment
} from 'common/state/coachingSessionAttachments';

function getFollowUpFromApiFollowUp(apiFollowUp) {
  const f = apiFollowUp;
  return {
    id: f.id,
    createdAt: f.created_at,
    createdByEmployeeId: f.created_by.id,
    createdByEmployeeFullName: f.created_by.full_name,
    createdByEmployeeImage: f.created_by.image,
    employeeId: f.employee_id,
    followUpableType: f.follow_upable.type,
    followUpableId: f.follow_upable.id,
    note: f.note,
  };
}

export const getFollowUps =
  ({
    followUpIds = null,
    solicitationIds = null,
    qaReviewIds = null,
    employeeIds = null,
  }) =>
  dispatch => {
    if (!followUpIds && !qaReviewIds && !employeeIds) {
      throw new Error(
        'At least one supported getFollowUps parameter is required'
      );
    }
    const params = {};
    if (followUpIds) params.ids = followUpIds;
    if (solicitationIds) params.solicitation_ids = solicitationIds;
    if (qaReviewIds) params.qa_review_ids = qaReviewIds;
    if (employeeIds) params.employee_ids = employeeIds;

    server.get('/api/v1/follow_ups', params).then(apiFollowUps =>
      dispatch({
        type: 'followUps/RECEIVED_FOLLOWUPS',
        followUps: apiFollowUps.follow_ups.map(getFollowUpFromApiFollowUp),
      })
    );
  };

export const followUpableTypes = {
  solicitation: 'solicitation',
  qaReview: 'qa_review',
};

export const addFollowUp =
  ({ followUpableType, followUpableId, note }) =>
  dispatch => {
    server
      .post('/api/v1/follow_ups', {
        follow_upable_type: followUpableType,
        follow_upable_id: followUpableId,
        note,
      })
      .then(apiFollowUp =>
        dispatch({
          type: 'followUps/RECEIVED_FOLLOWUPS',
          followUps: [getFollowUpFromApiFollowUp(apiFollowUp)],
          followUpableType,
          followUpableId,
        })
      );
  };

export const addSolicitationFollowUpAndAttachment =
  ({ coachingSessionId, solicitationId, note = '' }) =>
  dispatch => {
    server
      .post('/api/v1/follow_ups', {
        follow_upable_type: followUpableTypes.solicitation,
        follow_upable_id: solicitationId,
        note,
      })
      .then(apiFollowUp => {
        dispatch({
          type: 'followUps/RECEIVED_FOLLOWUPS',
          followUps: [getFollowUpFromApiFollowUp(apiFollowUp)],
          followUpableType: followUpableTypes.solicitation,
          followUpableId: solicitationId,
        });
        dispatch(
          createSolicitationAttachment(coachingSessionId, {
            solicitationId: apiFollowUp.follow_upable.id,
            followUpId: apiFollowUp.id,
          })
        );
      });
  };

export const addQaReviewFollowUpAndAttachment =
  ({ coachingSessionId, qaReviewId, score, note = '' }) =>
  dispatch => {
    server
      .post('/api/v1/follow_ups', {
        follow_upable_type: followUpableTypes.qaReview,
        follow_upable_id: qaReviewId,
        note,
      })
      .then(apiFollowUp => {
        dispatch({
          type: 'followUps/RECEIVED_FOLLOWUPS',
          followUps: [getFollowUpFromApiFollowUp(apiFollowUp)],
          followUpableType: followUpableTypes.qaReview,
          followUpableId: qaReviewId,
        });
        dispatch(
          createQaReviewAttachment(coachingSessionId, {
            qaReviewId,
            score,
            followUpId: apiFollowUp.id,
          })
        );
      });
  };

export const deleteFollowUp =
  ({ followUpId }) =>
  dispatch => {
    dispatch({
      type: 'followUps/DELETED_FOLLOWUP',
      followUpId,
    });
    server.delete(`/api/v1/follow_ups/${followUpId}`);
  };

export function followUps(state = [], action) {
  switch (action.type) {
    case 'followUps/RECEIVED_FOLLOWUPS': {
      const { followUps } = action;
      return [
        ...followUps,
        ...state.filter(followUp => !followUps.some(f => f.id === followUp.id)),
      ];
    }
    case 'followUps/DELETED_FOLLOWUP': {
      const { followUpId } = action;
      return state.filter(f => f.id !== followUpId);
    }
    default: {
      return state;
    }
  }
}
